<template>
  <div>
    <!-- 标题 -->
    <div class="database-title">
      <Breadcrumb>
        <BreadcrumbItem>{{ $t('aiMonitor.detailTitleDatabase') }}</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <!-- 查询框 -->
    <div class="database-top">
      <Row :gutter="4">
        <Col span="4">
          <DatePicker
            type="date"
            :options="options"
            :placeholder="$t('aiMonitor.selectDate')"
            v-model="timeType"
            @on-change="changeTimeType(timeType)"
            style="width: 100%;"
          ></DatePicker>
        </Col>
        <Col span="2">
          <Button
            @click="returnGo"
            v-hasPermission="['aiMonitor:applicationSystemAlarm:return']"
            >{{ $t('aiMonitor.return') }}</Button
          >
        </Col>
      </Row>
    </div>

    <Row :gutter="10" style="margin-bottom: 10px;">
      <!-- database -->
      <Col span="12">
        <Card :padding="8">
          <div id="RDSDiskSpaceUsage" style="width:100%;height: 240px;"></div>
        </Card>
      </Col>
      <Col span="12">
        <Card :padding="8">
          <div
            id="NumberofRDSDatabaseConnections"
            style="width:100%;height: 240px;"
          ></div>
        </Card>
      </Col>
    </Row>
    <Row :gutter="10" style="margin-bottom: 10px;">
      <!-- database -->
      <Col span="12">
        <Card :padding="8">
          <div id="cpu" style="width:100%;height: 240px;"></div>
        </Card>
      </Col>
      <Col span="12">
        <Card :padding="8">
          <div id="memory" style="width:100%;height: 240px;"></div>
        </Card>
      </Col>
    </Row>
    <Row :gutter="10" style="margin-bottom: 10px;">
      <!-- database -->
      <Col span="12">
        <Card :padding="8">
          <div id="readIOPS" style="width:100%;height: 240px;"></div>
        </Card>
      </Col>
      <Col span="12">
        <Card :padding="8">
          <div id="writeIOPS" style="width:100%;height: 240px;"></div>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
import { setCookie, getCookie } from "../../../utils/cookieUtil.js";
import utils from "../../../utils/utils.js";
export default {
  name: "DatabaseDetail",
  data() {
    return {
      options: {
        disabledDate(date) {
          return date && date.valueOf() >= new Date();
        }
      },
      timeType: "",
      // echarts实例
      chartCpu: "",
      chartMemory: "",
      chartReadIOPS: "",
      chartWriteIOPS: "",

      ChartRDSDiskSpaceUsage: "",
      chartNumberofRDSDatabaseConnections: "",
      // 数组
      cpuUsage: [],
      cpuUsagePrediction: [],
      memoryAvailable: [],
      memoryAvailablePrediction: [],
      readIops: [],
      readIopsPrediction: [],
      writeIops: [],
      writeIopsPrediction: [],
      xaxisData: [],

      RDSDiskSpaceUsageData: [],
      RDSDiskSpaceUsagePredictionData: [],
      NumberofRDSDatabaseConnectionsData: [],
      NumberofRDSDatabaseConnectionsPredictionData: []
    };
  },
  mounted: function() {
    this.currentDay();
    // 自适应不同屏幕尺寸
    const self = this;
    window.addEventListener("resize", function() {
      self.chartCpu.resize();
      self.chartMemory.resize();
      self.chartReadIOPS.resize();
      self.chartWriteIOPS.resize();
    });
  },
  methods: {
    // 默认显示当前日期
    currentDay: function() {
      const myDate = new Date();
      const year = myDate.getFullYear();
      const month = myDate.getMonth() + 1;
      const day = myDate.getDate();
      this.timeType = `${year}/${month}/${day}`;
      this.checkApplicationDataPoint();
    },
    // 返回上一页
    returnGo: function() {
      window.history.go(-1);
    },
    /******************查询********************************/
    // 折线图
    checkApplicationDataPoint: function() {
      this.$api.aiForecastDataPoint
        .checkApplicationDataPointStatistics({
          moduleId: this.$route.query.databaseId,
          timeHorizon: utils.methods.formatDate(this.timeType),
          moduleType: 1
        })
        .then(res => {
          if (res.data.xaxisData == undefined) {
            this.xaxisData = [];
          } else {
            this.xaxisData = res.data.xaxisData;
          }
          this.cpuUsage = res.data.cpuUsage;
          this.cpuUsagePrediction = res.data.cpuUsagePrediction;
          this.memoryAvailable = res.data.memoryAvailable;
          this.memoryAvailablePrediction = res.data.memoryAvailablePrediction;
          this.readIops = res.data.readIops;
          this.readIopsPrediction = res.data.readIopsPrediction;
          this.writeIops = res.data.writeIops;
          this.writeIopsPrediction = res.data.writeIopsPrediction;
          this.RDSDiskSpaceUsageData = res.data.rdsdiskSpaceUsageData;
          this.RDSDiskSpaceUsagePredictionData =
            res.data.rdsdiskSpaceUsagePredictionData;
          this.NumberofRDSDatabaseConnectionsData =
            res.data.numberofRDSDatabaseConnectionsData;
          this.NumberofRDSDatabaseConnectionsPredictionData =
            res.data.numberofRDSDatabaseConnectionsPredictionData;
          this.all();
        });
    },
    changeTimeType: function() {
      this.checkApplicationDataPoint();
    },
    /******************所有折线图********************************/
    all: function() {
      this.chartCpuLine();
      this.chartMemoryLine();
      this.chartReadIOPSLine();
      this.chartWriteIOPSLine();
      this.chartRDSDiskSpaceUsageLine();
      this.chartNumberofRDSDatabaseConnectionsLine();
    },
    /*************折线图*****************************/

    // RDS磁盘空间使用率
    chartRDSDiskSpaceUsageLine: function() {
      this.chartRDSDiskSpaceUsage = this.$echarts.init(
        document.getElementById("RDSDiskSpaceUsage")
      );
      this.chartRDSDiskSpaceUsage.setOption({
        title: {
          text: this.$t('aiMonitor.charts.rdsDiskSpaceUsage'),
          textStyle: {
            color: "#000", //颜色
            fontStyle: "normal", //风格
            fontWeight: "600", //粗细
            fontSize: 13 //大小
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: {
          x: "right",
          y: "18px",
          data: [this.$t('aiMonitor.charts.rdsDiskSpaceUsage'), this.$t('aiMonitor.charts.rdsDiskSpaceUsagePrediction')]
        },
        series: [
          {
            name: this.$t('aiMonitor.charts.rdsDiskSpaceUsage'),
            type: "line",
            data: this.RDSDiskSpaceUsageData,
            itemStyle: {
              normal: {
                color: "#61a0a8",
                lineStyle: {
                  color: "#61a0a8"
                }
              }
            }
          },
          {
            name: this.$t('aiMonitor.charts.rdsDiskSpaceUsagePrediction'),
            type: "line",
            data: this.RDSDiskSpaceUsagePredictionData,
            itemStyle: {
              normal: {
                color: "#c23159",
                lineStyle: {
                  color: "#c23159"
                }
              }
            }
          }
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      });
    },
    // RDS数据库连接数
    chartNumberofRDSDatabaseConnectionsLine: function() {
      this.chartNumberofRDSDatabaseConnections = this.$echarts.init(
        document.getElementById("NumberofRDSDatabaseConnections")
      );
      this.chartNumberofRDSDatabaseConnections.setOption({
        title: {
          text: this.$t('aiMonitor.charts.rdsDatabaseConnections'),
          textStyle: {
            color: "#000", //颜色
            fontStyle: "normal", //风格
            fontWeight: "600", //粗细
            fontSize: 13 //大小
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: {
          x: "right",
          y: "18px",
          data: [this.$t('aiMonitor.charts.rdsDatabaseConnections'), this.$t('aiMonitor.charts.rdsDatabaseConnectionsPrediction')]
        },
        series: [
          {
            name: this.$t('aiMonitor.charts.rdsDatabaseConnections'),
            type: "line",
            data: this.NumberofRDSDatabaseConnectionsData,
            itemStyle: {
              normal: {
                color: "#803500",
                lineStyle: {
                  color: "#803500"
                }
              }
            }
          },
          {
            name: this.$t('aiMonitor.charts.rdsDatabaseConnectionsPrediction'),
            type: "line",
            data: this.NumberofRDSDatabaseConnectionsPredictionData,
            itemStyle: {
              normal: {
                color: "#FF9B40",
                lineStyle: {
                  color: "#FF9B40"
                }
              }
            }
          }
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      });
    },

    // rds CPU使用率
    chartCpuLine: function() {
      this.chartCpu = this.$echarts.init(document.getElementById("cpu"));
      this.chartCpu.setOption({
        title: {
          text: this.$t('aiMonitor.charts.rdsCpuUsage'),
          textStyle: {
            color: "#000", //颜色
            fontStyle: "normal", //风格
            fontWeight: "600", //粗细
            fontSize: 13 //大小
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: {
          x: "right",
          y: "18px",
          data: [this.$t('aiMonitor.charts.rdsCpuUsage'), this.$t('aiMonitor.charts.rdsCpuUsagePrediction')]
        },
        series: [
          {
            name: this.$t('aiMonitor.charts.rdsCpuUsage'),
            type: "line",
            data: this.cpuUsage,
            itemStyle: {
              normal: {
                color: "#91c7ae",
                lineStyle: {
                  color: "#91c7ae"
                }
              }
            }
          },
          {
            name: this.$t('aiMonitor.charts.rdsCpuUsagePrediction'),
            type: "line",
            data: this.cpuUsagePrediction,
            itemStyle: {
              normal: {
                color: "#ceca58",
                lineStyle: {
                  color: "#ceca58"
                }
              }
            }
          }
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      });
    },
    // RDS内存使用率
    chartMemoryLine: function() {
      this.chartMemory = this.$echarts.init(document.getElementById("memory"));
      this.chartMemory.setOption({
        title: {
          text: this.$t('aiMonitor.charts.rdsMemoryUsage'),
          textStyle: {
            color: "#000", //颜色
            fontStyle: "normal", //风格
            fontWeight: "600", //粗细
            fontSize: 13 //大小
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: {
          x: "right",
          y: "18px",
          data: [this.$t('aiMonitor.charts.rdsMemoryUsage'), this.$t('aiMonitor.charts.rdsMemoryUsagePrediction')]
        },
        series: [
          {
            name: this.$t('aiMonitor.charts.rdsMemoryUsage'),
            type: "line",
            data: this.memoryAvailable,
            itemStyle: {
              normal: {
                color: "#ccc",
                lineStyle: {
                  color: "#ccc"
                }
              }
            }
          },
          {
            name: this.$t('aiMonitor.charts.rdsMemoryUsagePrediction'),
            type: "line",
            data: this.memoryAvailablePrediction,
            itemStyle: {
              normal: {
                color: "#4671D5",
                lineStyle: {
                  color: "#4671D5"
                }
              }
            }
          }
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      });
    },
    // rds 读IOPS
    chartReadIOPSLine: function() {
      this.chartReadIOPS = this.$echarts.init(
        document.getElementById("readIOPS")
      );
      this.chartReadIOPS.setOption({
        title: {
          text: this.$t('aiMonitor.charts.rdsReadIops'),
          textStyle: {
            color: "#000", //颜色
            fontStyle: "normal", //风格
            fontWeight: "600", //粗细
            fontSize: 13 //大小
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: {
          x: "right",
          y: "18px",
          data: [this.$t('aiMonitor.charts.rdsReadIops'), this.$t('aiMonitor.charts.rdsReadIopsPrediction')]
        },
        series: [
          {
            name: this.$t('aiMonitor.charts.rdsReadIops'),
            type: "line",
            data: this.readIops,
            itemStyle: {
              normal: {
                color: "#61a0a8",
                lineStyle: {
                  color: "#61a0a8"
                }
              }
            }
          },
          {
            name: this.$t('aiMonitor.charts.rdsReadIopsPrediction'),
            type: "line",
            data: this.readIopsPrediction,
            itemStyle: {
              normal: {
                color: "#c23159",
                lineStyle: {
                  color: "#c23159"
                }
              }
            }
          }
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      });
    },
    // rds 写IOPS
    chartWriteIOPSLine: function() {
      this.chartWriteIOPS = this.$echarts.init(
        document.getElementById("writeIOPS")
      );
      this.chartWriteIOPS.setOption({
        title: {
          text: this.$t('aiMonitor.charts.rdsWriteIops'),
          textStyle: {
            color: "#000", //颜色
            fontStyle: "normal", //风格
            fontWeight: "600", //粗细
            fontSize: 13 //大小
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: {
          x: "right",
          y: "18px",
          data: [this.$t('aiMonitor.charts.rdsWriteIops'), this.$t('aiMonitor.charts.rdsWriteIopsPrediction')]
        },
        series: [
          {
            name: this.$t('aiMonitor.charts.rdsWriteIops'),
            type: "line",
            data: this.writeIops,
            itemStyle: {
              normal: {
                color: "#803500",
                lineStyle: {
                  color: "#803500"
                }
              }
            }
          },
          {
            name: this.$t('aiMonitor.charts.rdsWriteIopsPrediction'),
            type: "line",
            data: this.writeIopsPrediction,
            itemStyle: {
              normal: {
                color: "#FF9B40",
                lineStyle: {
                  color: "#FF9B40"
                }
              }
            }
          }
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      });
    }
  }
};
</script>

<style scoped>
.database-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 8px 4px;
  font-weight: 600;
}

.ivu-col-span-6 {
  margin-bottom: 20px;
}

.database-top {
  width: 100%;
  height: 53px;
  background-color: #fff;
  padding: 4px 0px 0px 0px;
}

.ivu-breadcrumb {
  font-size: 13px;
  font-weight: 600;
  color: #515a6e;
}
</style>



// WEBPACK FOOTER //
// src/components/ai_monitor/ai_dashboard/DatabaseDetail.vue